import { RouteHelper } from './../../helpers/route.helpers';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import * as $ from 'jquery';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor(
    public routeHelper: RouteHelper
  ) {
    this.dateNow = moment().format('YYYY');
  }

  dateNow: string;
  data: any;
  tinySliderConfig: any;

  remittanceFg = new FormGroup({
    transferFrom: new FormControl('', Validators.required),
    transferTo: new FormControl('', Validators.required),
    rateValue: new FormControl(''),
  });


  ngOnInit(): void {
    $.getScript('./assets/js/tiny-slider.js');
    $.getScript('./assets/js/plugins.init.js');
    window.scrollTo(0, 0);
  }
}
